export default {
  data() {
    return {
      productCategoryList: [],
      joinTypeList: []
    }
  },
  mounted() {
    this.getProductCategoryList()
    this.getJoinTypeList()
  },
  methods: {
    getRequestParams(params) {
      const requestParams = {
        ...params,
        ...params.limitDto
      }
      delete requestParams.limitDto
      return requestParams
    },
    getProductCategoryList() {
      const url = 'zwy/combo/productCategoryList'
      this.getHttpServices().getSourceService().get(url)
        .then((list) => {
          this.productCategoryList = list ? list.map(item => {
            return {
              ...item,
              label: item.key
              // value: item.value
            }
          }) : []
        })
    },
    getJoinTypeList() {
      const url = 'zwy/combo/joinTypeList'
      this.getHttpServices().getSourceService().get(url)
        .then(list => {
          this.joinTypeList = list ? list.map(item => {
            return {
              ...item,
              label: item.key
              // value: item.value
            }
          }) : []
        }).catch(err => {
        console.log(err)
      })
    },
    getTypeName(type, list) {
      if (type && list && list.length > 0) {
        const findItem = list.find(item => String(item.value) === String(type))
        return findItem ? findItem.label : '--'
      }
      return ''
    },
    /**
     * @param url
     * @param params
     * @param successCallback
     */
    requestGet(url, params, successCallback) {
      this.getHttpServices().getSourceService().get(url, params)
        .then(res => {
          console.log(res)
          if (successCallback && typeof successCallback === 'function') {
            successCallback()
          }
          this.$message.success('操作成功')
        })
        .catch(err => {
          if (err.msg) {
            this.$message.error(err.msg)
          } else {
            this.$message.error('操作失败，请重试！')
          }
          console.error(err)
        })
    },
    requestPost(url, data, successCallback) {
      this.getHttpServices().getSourceService().post(url, data)
        .then(res => {
          console.log(res)
          if (successCallback && typeof successCallback === 'function') {
            successCallback(res)
          }
          this.$message.success('操作成功')
        })
        .catch(err => {
          if (err.msg) {
            this.$message.error(err.msg)
          } else {
            this.$message.error('操作失败，请重试！')
          }
          console.error(err)
        })
    }
  }
}